import styled from 'styled-components';

export const Bar = styled.div`
  width: 100%;
  margin-top: -20px;
`;
